export default {
  applyWildCards(string) {
    return '*' + string + '*'
  }
}
